import { Navigate, useLocation } from "react-router-dom";

const RequireRole = ({ role, children }) => {
  const location = useLocation();

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== role) {
    return user.role === "Admin"
      ? <Navigate to="/admin" replace />
      : <Navigate to="/user" replace />;
  }

  return children;
};

export default RequireRole;
